module.exports = __webpack_public_path__ + "img/formsHalbkreis.d5adc702.svg";